import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card p-4 text-center" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "row pb-3" }
const _hoisted_4 = { class: "col-md-4 offset-md-4" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-0" }, "Access to this brand requires a passcode.", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-muted" }, "Passcodes are provided by your institution", -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { for: "passcode" }, "Enter passcode", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control text-center",
              type: "text",
              name: "passcode",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passcode) = $event))
            }, null, 512), [
              [_vModelText, _ctx.passcode]
            ]),
            (_ctx.passcode_error !== '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.passcode_error), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitPasscode && _ctx.submitPasscode(...args))),
            disabled: _ctx.passcode.length === 0
          }, _cache[2] || (_cache[2] = [
            _createTextVNode("Submit Passcode "),
            _createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
          ]), 8, _hoisted_6)
        ])
      ])
    ]),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}